import Enum from './Enum.js';

export default class Provider extends Enum {
    static get entries() {
        return {
            magnetis: 158,
            trs: 9803,
        };
    }

    static get MAGNETIS() {
        return this.entries.magnetis;
    }

    static get TRS() {
        return this.entries.trs;
    }
}
